import { createAction } from 'redux-actions';
import { OTPVerifyUser, OTPVerifyTaxpayer } from './Types';
import { ValidateTaxpayerOtpRequest } from '../../Services/ClientProxy/clientProxy';
import { ProfileManagementService } from '../../Services/ProfileManagement/Service';

const ProfileManagement = new ProfileManagementService();

export const otpVerifyUser = createAction(
    OTPVerifyUser,
    async (request: ValidateTaxpayerOtpRequest, code?: string) => {
        try {
            await ProfileManagement.otpVerifyUserService(request, code);
        } catch (serviceError) {
            return { lastError: serviceError, request };
        }
        return { lastError: null, request };
    }
);

export const otpVerifyTaxpayer = createAction(
    OTPVerifyTaxpayer,
    async (request: ValidateTaxpayerOtpRequest, code?: string) => {
        try {
            await ProfileManagement.otpVerifyTaxpayerProfleService(
                request,
                code
            );
        } catch (serviceError) {
            return { lastError: serviceError, request };
        }
        return { lastError: null, request };
    }
);
